var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<label for=\"{{id}}\" ng-if=\"label !== undefined\" class=\"control-label {{labelClass}}\">{{label}}</label>\n<div class=\"input-group\">\n<span class=\"input-group-addon\">\n<i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n</span>\n<input id=\"{{id}}\" type=\"text\" class=\"form-control\" ng-model=\"model\" placeholder=\"{{placeholder}}\"/>\n</div>\n";
var id1="app/_directives/pkp-search-box.directive.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;